
import React, { Component } from 'react';
import {
  Backdrop,
  CircularProgress,
  Snackbar,
  Grid
} from '@material-ui/core';
import i18n from '../i18n';
import SkuTable from '../components/SkuCarryover/SkuTable';
import AddSkuSpreadsheet from '../components/SkuCarryover/AddSkuSpreadsheet';
import GenericConfirmActionModal from '../components/GenericConfirmActionModal';

import '../assets/stylesheets/SearchView.css';
import { mergeSkus } from '../helpers/externalRequests';

class SkuCarryoverView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openBackdrop: false,
      skus: [],
      snackbarOpen: false,
      snackbarMessage: '',
      showMergeConfirmationModal: false,
      showSkuDeletionModal: false,
      rowsSelected: [],
    };
  }

  handleMergeResponse = (response) => {
    const {
      rowsSelected,
      skus,
    } = this.state;

    const rowsSelectedCopy = [...rowsSelected];

    const failedSkus = response.data.failedCarryover || [];
    failedSkus.forEach(failedSkuPair => {
      // remove failed skus from rowsSelected for a count of skus successfully merged
      rowsSelectedCopy.splice(
        rowsSelectedCopy.findIndex(row => row.id === failedSkuPair.id), 1);
      // update the failed sku status
      const match = skus.find(sku => sku.id === failedSkuPair.id);
      if (match) {
        match.status = 'failed';
      }
    });
    // remove sucessful skus
    const skusUpdated = [...skus].filter(sku => rowsSelectedCopy.every(row => row.id !== sku.id));
    const skusMergedCount = rowsSelectedCopy.length;
    this.openSnackbar(i18n.t('carryover:mergeSuccess', { nb: skusMergedCount }));

    this.setState({ skus: skusUpdated, rowsSelected: [] })
  }

  mergeInBackend = () => {
    // close the merge modal
    this.toggleMergeSkusModal();
    const { rowsSelected } = this.state;

    this.setState({ openBackdrop: true }, () => {
      const data = { carryovers: [] }

      rowsSelected.forEach(row => {
        data.carryovers.push({ oldProductCode: row.oldSku, newProductCode: row.newSku, id: row.id });
      });

    mergeSkus(data)
      .then((response) => {
        this.setState({ openBackdrop: false });
        this.handleMergeResponse(response)
      })
      .catch((error) => {
        this.setState({ openBackdrop: false });
        this.openSnackbar(`${i18n.t('carryover:connectionFailed')} ${error?.message}`);
      })
    });    
  }

  deleteRows = () => {
    const { rowsSelected, skus } = this.state;

    rowsSelected.forEach((row) => {
      skus.splice(skus.indexOf(row), 1)
    });

    this.openSnackbar(i18n.t('carryover:deleteSuccess', { nb: rowsSelected.length }));
    this.setState({ skus, rowsSelected: [] });
    this.toggleDeleteSkusModal();
  }

  // following method gets called from AddSkuSpreadsheet; here the additional status is added to every sku pair.
  returnSkus = skuPairs => {
    const { skus } = this.state;

    const updatedSkus = [...skus];

    skuPairs.forEach((skuPair) => {
      const id = `${skuPair.oldSku}${skuPair.newSku}`;
      // add the skuPair if it is not aleady there
      if ((updatedSkus.find(sku => sku.id === id) === undefined) ) {
        const skuPairWithStatus = {
          ...skuPair,
          status: '',
          id,
        }
        updatedSkus.push(skuPairWithStatus)
      }
    });

    this.setState({ skus: updatedSkus });
  };

  toggleMergeSkusModal = () => {
    this.setState((prevState) => {
      const showMergeConfirmationModal = !prevState.showMergeConfirmationModal;
      return { showMergeConfirmationModal };
    });
  };

  toggleDeleteSkusModal = () => {
    this.setState((prevState) => {
      const showSkuDeletionModal = !prevState.showSkuDeletionModal;
      return { showSkuDeletionModal };
    });
  }

  handleClickMerge = (event, data) => {
    this.setState({ rowsSelected: data }, () => {
      this.toggleMergeSkusModal();
    });
  }

  handleClickDelete = (event, data) => {
    this.setState({ rowsSelected: data }, () => {
      this.toggleDeleteSkusModal();
    });
  }

  closeSnackbar = () => {
    this.setState({ snackbarOpen: false, snackbarMessage: '' });
  };

  openSnackbar = message => {
    this.setState({ snackbarMessage: message, snackbarOpen: true });
  };
  
  render() {
    const {
      openBackdrop,
      snackbarMessage,
      snackbarOpen,
      showMergeConfirmationModal,
      showSkuDeletionModal,
      skus,
      rowsSelected,
    } = this.state;

    return (
      <>
        <Grid container className="skuTableView">
          <Grid item xs={5} sm={4} md={3}>
            <Grid item xs={12}>
              <AddSkuSpreadsheet
                refreshSkus={this.returnSkus}
              />
            </Grid>
          </Grid>
          <Grid item xs={4} sm={5} md={6}>
            <SkuTable
              skus={skus}
              onClickMerge={this.handleClickMerge}
              onClickDelete={this.handleClickDelete}
            />
          </Grid>
          <Snackbar
            message={snackbarMessage}
            open={snackbarOpen}
            onClose={this.closeSnackbar}
            autoHideDuration={2000}
          />
          {showMergeConfirmationModal && (
            <GenericConfirmActionModal
              showModal={showMergeConfirmationModal}
              confirmMessage={i18n.t('carryover:confirmMerge', { nb: rowsSelected.length })}
              confirmTitle={i18n.t('carryover:confirmMergeBtn')}
              onClose={this.toggleMergeSkusModal}
              onConfirm={this.mergeInBackend}
            />
          )}
          {showSkuDeletionModal && (
            <GenericConfirmActionModal
              showModal={showSkuDeletionModal}
              confirmMessage={i18n.t('carryover:confirmDelete', { nb: rowsSelected.length })}
              confirmTitle={i18n.t('carryover:confirmDeleteBtn')}
              onClose={this.toggleDeleteSkusModal}
              onConfirm={this.deleteRows}
            />
          )}
        </Grid>
        <Backdrop open={openBackdrop} className="backdrop">
          <CircularProgress color="inherit" />
        </Backdrop>
      </>
    );
  }
}

export default SkuCarryoverView;
